'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pikaday = require('pikaday');

var _pikaday2 = _interopRequireDefault(_pikaday);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectorFechaDirective = function () {
    function SelectorFechaDirective(fechaConfig, $timeout, utilFactory) {
        _classCallCheck(this, SelectorFechaDirective);

        this.fechaConfig = fechaConfig;
        this.$timeout = $timeout;
        this.utilFactory = utilFactory;
        this.require = 'ngModel';
        this.scope = {
            minDate: "=",
            maxDate: "="
        };
    }

    _createClass(SelectorFechaDirective, [{
        key: 'link',
        value: function link(scope, elem, attrs, ngModel) {
            var _this = this;

            var picker = new _pikaday2.default({
                field: elem[0],
                minDate: scope.minDate,
                maxDate: scope.maxDate,
                firstDay: 1,
                format: this.fechaConfig.FORMATO_FECHA.toUpperCase(),
                i18n: {
                    previousMonth: 'Siguiente',
                    nextMonth: 'Anterior',
                    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                    weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                    weekdaysShort: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
                },
                onSelect: function onSelect(date) {
                    scope.$parent.$apply();
                }
            });

            var setPickerDate = function setPickerDate(event) {
                if (event && event.type == "keyup" && event.which != 13) return;
                if (!ngModel.$modelValue) return;

                if (typeof ngModel.$modelValue == "string") {
                    picker.setDate(_this.utilFactory.convertirFecha(ngModel.$modelValue));
                } else {
                    picker.setDate(ngModel.$modelValue);
                }
            };

            scope.$watch('minDate', function () {
                if (!scope.minDate) return;
                picker.setMinDate(scope.minDate);
            });

            scope.$watch('maxDate', function () {
                if (!scope.maxDate) return;
                picker.setMaxDate(scope.maxDate);
            });

            this.$timeout(setPickerDate);

            elem.on("blur", setPickerDate);
            elem.on("keyup", setPickerDate);
        }
    }]);

    return SelectorFechaDirective;
}();

SelectorFechaDirective.$inject = ['fechaConfig', '$timeout', 'utilFactory'];

exports.default = SelectorFechaDirective;


// WEBPACK FOOTER //
// ./src/busqueda/directivas/selector-fecha.directive.js